/*
// awardRules.js
const parseRatingValue = (value) => {
  if (value === null || value === undefined || value === '') return null;
  if (typeof value === 'number') return Number.isFinite(value) ? value : null;
  if (typeof value === 'string') {
    const parsed = Number(value.replace(',', '.').trim());
    return Number.isFinite(parsed) ? parsed : null;
  }
  return null;
};

export const calculateAwardsForUser = (user, eventsList) => {
  if (!user.hosted_events) return [];

  const awards = [];
  const eventTypes = user.hosted_events.map(event => event.split(', ')[1]);
  const uniqueEventTypes = new Set(eventTypes);

  // Festivity Specialist: same event type 2+ times
  const eventCounts = user.hosted_events.reduce((acc, event) => {
    const eventType = event.split(', ')[1];
    if (["Vino🍷", "Blåtur🌍", "KL🥩", "KD🧠"].includes(eventType)) {
      acc[eventType] = (acc[eventType] || 0) + 1;
    }
    return acc;
  }, {});
  const repeatedType = Object.entries(eventCounts).find(([_, count]) => count >= 2);
  if (repeatedType) {
    awards.push({
      name: "⚜️Festivity Specialist⚜️",
      reason: `Arrangert ${repeatedType[0]} ${repeatedType[1]} ganger`
    });
  }

  // Maestro of Ceremonies
  if (["Vino🍷", "Blåtur🌍", "KL🥩", "KD🧠"].every(type => uniqueEventTypes.has(type))) {
    awards.push({
      name: "🥇Maestro of Ceremonies🥇",
      reason: "Arrangert minst en av hver type (Vino, Blåtur, KL, KD)"
    });
  }

  // KL Score Master
  const klScoreMasterEvents = eventsList.filter(
    e => e.event_type === "KL🥩" && (parseRatingValue(e.rating) ?? -1) > 3.6 && Array.isArray(e.Vert) && e.Vert.includes(user.name)
  );
  if (klScoreMasterEvents.length > 0) {
    awards.push({
      name: "🎗️KL Score Master🎗️",
      reason: "Arrangert KL🥩 med KL-rating over 3.6"
    });
  }

  // Vino Sommelier
  const vinoCount = eventTypes.filter(t => t === "Vino🍷").length;
  if (vinoCount >= 3) {
    awards.push({
      name: "🍷Vino Sommelier🍷",
      reason: `Arrangert ${vinoCount} Vino🍷 ganger`
    });
  }

  // KL Connoisseur
  const klCount = eventTypes.filter(t => t === "KL🥩").length;
  if (klCount >= 3) {
    awards.push({
      name: "🥩KL Connoisseur🥩",
      reason: `Arrangert ${klCount} KL🥩`
    });
  }

  // Blåtur Voyager
  const blaturCount = eventTypes.filter(t => t === "Blåtur🌍").length;
  if (blaturCount >= 3) {
    awards.push({
      name: "🌍Blåtur Voyager🌍",
      reason: `Arrangert ${blaturCount} Blåtur🌍`
    });
  }

  return awards;
};
*/
// awardRules.js
export const calculateAwardsForUser = (user, eventsList) => {
  if (!user.hosted_events) return [];

  const awards = [];
  const eventTypes = user.hosted_events.map(event => event.split(', ')[1]);
  const uniqueEventTypes = new Set(eventTypes);

  // Festivity Specialist: same event type 2+ times
  const eventCounts = user.hosted_events.reduce((acc, event) => {
    const eventType = event.split(', ')[1];
    if (["Vino🍷", "Blåtur🌍", "KL🥩", "KD🧠"].includes(eventType)) {
      acc[eventType] = (acc[eventType] || 0) + 1;
    }
    return acc;
  }, {});
  const repeatedType = Object.entries(eventCounts).find(([_, count]) => count >= 2);
  if (repeatedType) {
    awards.push({
      name: "⚜️Festivity Specialist⚜️",
      reason: `Arrangert ${repeatedType[0]} ${repeatedType[1]} ganger`
    });
  }

  // Maestro of Ceremonies
  if (["Vino🍷", "Blåtur🌍", "KL🥩", "KD🧠"].every(type => uniqueEventTypes.has(type))) {
    awards.push({
      name: "🥇Maestro of Ceremonies🥇",
      reason: "Arrangert minst en av hver type (Vino, Blåtur, KL, KD)"
    });
  }

  // 🏅 Golden Hat Trick 🏅
  if (
    uniqueEventTypes.has("KL🥩") &&
    uniqueEventTypes.has("Vino🍷") &&
    uniqueEventTypes.has("Blåtur🌍")
  ) {
    awards.push({
      name: "🏅Golden Hat Trick🏅",
      reason: "Har arrangert minst én KL🥩, én Vino🍷 og én Blåtur🌍"
    });
  }

  // KL Score Master
  const klScoreMasterEvents = eventsList.filter(
    e => e.event_type === "KL🥩" && e.rating > 3.6 && Array.isArray(e.Vert) && e.Vert.includes(user.name)
  );
  if (klScoreMasterEvents.length > 0) {
    awards.push({
      name: "🎗️KL Score Master🎗️",
      reason: "Arrangert KL🥩 med KL-rating over 3.6"
    });
  }

  // Vino Sommelier
  const vinoCount = eventTypes.filter(t => t === "Vino🍷").length;
  if (vinoCount >= 3) {
    awards.push({
      name: "🍷Vino Sommelier🍷",
      reason: `Arrangert ${vinoCount} Vino🍷 ganger`
    });
  }

  // KL Connoisseur
  const klCount = eventTypes.filter(t => t === "KL🥩").length;
  if (klCount >= 3) {
    awards.push({
      name: "🥩KL Connoisseur🥩",
      reason: `Arrangert ${klCount} KL🥩`
    });
  }

  // Blåtur Voyager
  const blaturCount = eventTypes.filter(t => t === "Blåtur🌍").length;
  if (blaturCount >= 3) {
    awards.push({
      name: "🌍Blåtur Voyager🌍",
      reason: `Arrangert ${blaturCount} Blåtur🌍`
    });
  }

  return awards;
};